import * as React from 'react';
import { memo, useEffect, useState } from 'react';
import theme from './ClickHint.module.scss';
export var ClickHint = memo(function (_a) {
    var _b = _a.text, text = _b === void 0 ? 'Click to add a note' : _b, visibleProp = _a.visible, _c = _a.keepTrackingCoords, keepTrackingCoords = _c === void 0 ? false : _c, coords = _a.coords;
    var _d = useState({ x: 0, y: 0 }), coordsState = _d[0], setCoords = _d[1];
    var validCoordsProvided = coords && coords.x >= 0 && coords.y >= 0;
    var visible = visibleProp || validCoordsProvided;
    var shouldTrackCoords = !coords && (visible || keepTrackingCoords);
    useEffect(function () {
        if (shouldTrackCoords) {
            var onMove_1 = function (e) { return setCoords({ x: e.clientX, y: e.clientY }); };
            document.addEventListener('mousemove', onMove_1);
            return function () {
                document.removeEventListener('mousemove', onMove_1);
            };
        }
        return undefined;
    }, [setCoords, shouldTrackCoords]);
    var _e = coords !== null && coords !== void 0 ? coords : coordsState, x = _e.x, y = _e.y;
    return (React.createElement("div", { className: theme.container, children: text, style: {
            display: visible ? 'block' : 'none',
            transform: "translate(" + x + "px, " + y + "px)",
        } }));
});
//# sourceMappingURL=ClickHint.js.map